import { useQuery } from "@tanstack/react-query";
import { departmentsApi } from "@/shared/services/departmentsApi";

export const useDepartments = (enabled = true) =>
  useQuery({
    enabled,
    queryKey: ["departments"],
    queryFn: departmentsApi.getAll,
    staleTime: 10 * 60 * 1000, // departments rarely change — 10 min cache
  });
